import WebPage from "./web_page";
export default function WebPageWrapper({ webPage }) {
  return <WebPage webPageType={webPage} />;
}
